import { useQuery } from 'react-query';
import {useLocation} from 'react-router-dom';
import { getItem } from 'src/js/utils';
import { REACT_QUERY_NAMES as RQN } from 'newJs/config';
import {setPageTitle} from 'newJs/utils';
import {useMessageStore} from 'state/index';
import flagUtil from 'newJs/containers/MailFlags/utils';

const fetchMailData = async (fetch, query) => await fetch(query);

const useFetchEmail = (args) => {
    const location = useLocation();
    const setEmlData = useMessageStore((state) => state.setEmlData);
    const setEmlFlags = useMessageStore((state) => state.setEmlFlags);
    const {
        MAPI, currentFolder, enabled = true, maiList, msgUID,
        additionalQueryParams: query,
    } = args;

    const initialMessageData = getItem(maiList?.messages, parseFloat(msgUID), false, 'current');
    const folder = currentFolder || initialMessageData?.folder;
    const requestUrl = new URL(MAPI.v2.messages(folder, msgUID));
    if (typeof query === 'object' && Object.keys(query).length > 0) {
        requestUrl.search = new URLSearchParams(query).toString();
    }

    return useQuery(
        [
            RQN.get('SINGLE-MAIL-DATA'),
            folder, // folder key
            msgUID, // messageid key
            query
        ],
        () => fetchMailData(MAPI.fetch, {
            cache: false,
            url: requestUrl.href,
        }),
        {
            enabled: !!msgUID && enabled, // 👈 if msg id is
            retry: false, // MAIL-6279 - do not retry, allow user immediately show error, if user switches between msgs or opens deleted msg
            // FIXME: Future update add specific query to not fetch already opened message (then do not forget about all bugs..)
            onSuccess: (res) => {
                setEmlData(res);
                if (res?.flags) {
                    setEmlFlags(flagUtil.normalizeArray(res.flags));
                }
                if (location.pathname.includes('/message')) {
                    setPageTitle(null, 'message');
                }
            }
        }
    );
};
export default useFetchEmail;

